<template>
  <section>
    <div
      id="myChart"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: null,
      dataValue: [],
      yName: [],
      mountData: "",
      updateData: "",
      fullDiv: {
        top: "28%",
        left: "10%",
      },
    };
  },
  props: {
    boxHeight: {
      default: 21,
      type: Number,
    },
    showtime: {
      default: false,
      type: Boolean,
    },
    showLegend: {
      default: false,
      type: Boolean,
    },
    coordinateName: {
      default: "",
      type: String,
    },
  },

  components: {},

  mounted() {
    let that = this;
    window.onresize = function () {
      that.myChart.resize();
    };
    if (window.outerWidth <= 1920) {
      this.fullDiv = {
        left: "5%",
        right: "5%",
        bottom: "1%",
        top: "30%",
        containLabel: true,
      };
    }
  },
  watch: {},
  methods: {
    upDateChart(content) {
      // console.log("content", content);
      this.myChart.setOption({
        series: (() => {
          let list = [];
          content.seriseList.map((li, l_index) => {
            let _color = li.color ? li.color : this.getColor();
            console.log("li", li);
            let item = {
              type: li.type,
              data: li.data,
              name: li.name,
              label: li.label,
              smooth: true,
              showSymbol: li.label ? true : false,
              lineStyle: {
                color: _color,
                type: li.lineType ? li.lineType : "solid",
              },
              emphasis: {
                focus: "series",
              },
              areaStyle: {
                opacity: li.areaOpacity ? 1 : 0,
                color: li.areaColor,
              },
              itemStyle: {
                color: _color,
              },
              // yAxisIndex: li.yAxisIndex ? li.yAxisIndex : 0,
            };
            list.push(item);
          });
          // console.log("list", list);
          return list;
        })(),
        legend: content.tooltip,
      });
    },
    myEcharts(data) {
      let echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.myChart);
      this.setChartData(data);
      // 指定图表的配置项和数据
    },
    setChartData(data) {
      // console.log("data", data);
      let option = {
        xAxis: {
          //   max: "dataMax",
          data: data.xData,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            fontSize: this.$common.setFontSize(0.69),
          },
        },
        yAxis: {
          name: data.yName ? data.yName : "百万吨",
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(204, 204, 204, 0.2)",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            fontSize: this.$common.setFontSize(0.77),
          },
          nameTextStyle: {
            fontSize: this.$common.setFontSize(0.77),
            color: this.$color,
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 30,
            height: "80%",
            showDataShadow: false,
            left: "93%",
          },
        ],
        series: (() => {
          let list = [];
          data.seriseList.map((li, l_index) => {
            let _color = li.color ? li.color : this.getColor();
            let item = {
              type: li.type,
              data: li.data,
              name: li.name,
              label: li.label,
              smooth: li.smooth ? true : false,
              showSymbol: li.label ? true : false,
              lineStyle: {
                color: _color,
                type: li.lineType ? li.lineType : "solid",
              },
              emphasis: {
                focus: "series",
              },
              areaStyle: {
                opacity: li.areaOpacity ? 1 : 0,
                color: li.areaColor,
              },
              itemStyle: {
                color: _color,
              },
              endLabel: li.endLabel,
              // yAxisIndex: li.yAxisIndex ? li.yAxisIndex : 0,
            };
            list.push(item);
          });
          return list;
        })(),
        // [
        //   {
        //     // name: "X",
        //     type: "line",
        //     data: data.seriseList[0].data, //dataArr,
        //     smooth: true,
        //     markPoint: {
        //       data: [
        //         {
        //           value: 300,
        //           coord: [1, 277.87],
        //           symbolSize: 0,
        //           symbolOffset: [0, -10],
        //         },
        //       ],
        //     },
        //   },
        // ],
        legend: {
          icon: "circle",
          itemHeight: 10,
          data: (() => {
            let list = [];
            data.seriseList.map((li, l_index) => {
              list.push(li.name);
            });
            return list;
          })(),
          textStyle: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.77),
          },
          // x: "center",
          top: 10,
          left: "18%",
          // right: "10%",
          // orient: "'vertical'",
        },
        tooltip: data.tooltip,
        grid: data.fullDiv ? data.fullDiv : this.fullDiv,
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
    setFontSize(val) {
      // console.log("val", val);
      const baseSize = 15;
      const scale = document.documentElement.clientWidth / 1920;
      const nowSize = baseSize * Math.min(scale, 2);
      // console.log("val * nowSize", val, nowSize);
      return val * nowSize;
    },
    getColor() {
      return (
        "#" +
        ("00000" + ((Math.random() * 0x1000000) << 0).toString(16)).substr(-6)
      );
    },
    destroyedChart() {
      if (this.myChart) {
        this.myChart.dispose();
      }
    },
  },
  destroyed() {
    // this.bus.$off("updateData");
  },
};
</script>
<style lang='scss' scoped>
</style>